import './_privacySettings.scss'
import { useEffect, useState } from 'react'

import { useTranslation } from 'react-i18next'
import { useMutation } from 'react-query'

import { addToast } from 'components/Toast/Toast'
import { ActionCard } from 'components-ref/molecules/ActionCard/ActionCard'
import WithHeaderSection from 'layouts/WithHeaderSection/WithHeaderSection'
import { updateTwoFactorAuthType } from 'services/endpoints/profile'
import { useUserProfile } from 'store'

export const TwoStepVerification = () => {
    const { t } = useTranslation()
    const userData = useUserProfile()

    const isAppAuthenticator = userData?.two_factor_auth_type === 'qr_authenticator'
    const isSMSAuthenticator = userData?.two_factor_auth_type === 'sms'

    const [switchBtn, setSwitchBtn] = useState({
        firstCard: false,
        secondCard: false
    })

    const { mutate: updateAuthType } = useMutation(updateTwoFactorAuthType, {
        onError: (error) => {
            console.error('Failed to update auth type:', error)
        },
        onSuccess: () => {
            addToast('success', t('Auth type updated successfully'))
        }
    })

    useEffect(() => {
        setSwitchBtn({
            firstCard: isAppAuthenticator,
            secondCard: isSMSAuthenticator
        })
    }, [isAppAuthenticator, isSMSAuthenticator])

    const handleToggle = (type: 'firstCard' | 'secondCard') => {
        setSwitchBtn(prev => {
            const newState = {
                ...prev,
                [type]: !prev[type]
            }

            // If the toggle is being turned off, call the API to set it to null
            if (!newState[type]) {
                // Check if two_factor_auth_type is not null before making the API call
                if (userData?.two_factor_auth_type !== null && (switchBtn[type] && type === 'firstCard' ? isAppAuthenticator : isSMSAuthenticator)) {
                    // This is when the user disables the toggle
                    updateAuthType({ type: null })
                }
            } 
            return newState
        })
    }

    const twoFactorAuthenticationCards = [
        {
            id: 1,
            link: '/settings/account/privacy-and-security/two-step-verification/authentificator-app',
            hasArrow: true,
            hasToggle: true,
            toggleActive: switchBtn.firstCard,
            text: t('authenticatorApp'),
            toggleFn: () => handleToggle('firstCard'),
            customClass: 'twoFactorAuthentication__card'
        },
        {
            id: 2,
            link: '/settings/account/privacy-and-security/two-step-verification/sms-verification',
            hasArrow: true,
            hasToggle: true,
            toggleActive: switchBtn.secondCard,
            text: t('smsVerification'),
            toggleFn: () => handleToggle('secondCard'),
            customClass: 'twoFactorAuthentication__card'
        }
    ]

    return (
        <WithHeaderSection
            headerSection={
                <>
                    <h2 className='singlesetting__section'>
                        {t('privacySecurity')}
                    </h2>
                    <h1 className='singlesetting__section__title'>
                        {t('twoStepAuthentication')}
                    </h1>
                </>
            }
        >
            <div>
                {twoFactorAuthenticationCards.map(item => (
                    <ActionCard
                        key={item.id}
                        link={item.link}
                        text={item.text}
                        hasArrow={item.hasArrow}
                        hasSwitch={item.hasToggle}
                        toggleActive={item.toggleActive}
                        toggleFn={item.toggleFn}
                    />
                ))}
            </div>
        </WithHeaderSection>
    )
}
